module.exports = __webpack_public_path__ + "img/9788958281733.baed609a.jpg";